@if (this.config().menuItems; as menuItems) {
  <div
    [class]="
      'flex flex-col rounded-(--list-menu-border-radius) overflow-hidden ' +
      (config().shadow ? 'shadow-(--list-menu-shadow) ' : '') +
      (config().border
        ? 'border-(length:--list-menu-border-width,var(--border-width-xs)) border-(--list-menu-border-color)'
        : '')
    "
  >
    @for (item of menuItems; track $index; let isLast = $last) {
      <button
        (click)="onItemClick(item)"
        [disabled]="disabled() || item.disabled"
        [class.opacity-50]="disabled() || item.disabled"
        [style.border-bottom]="
          !isLast
            ? 'var(--list-menu-divider-width, var(--border-width-xs)) solid var(--list-menu-divider-color, var(--list-menu-border-color))'
            : 'none'
        "
        [style.font-family]="'var(--list-menu-font-family)'"
        class="flex items-center gap-(--list-menu-gap) px-(--list-menu-padding-x) py-(--list-menu-padding-y) text-left w-full transition-colors [background:var(--list-menu-background)] enabled:cursor-pointer enabled:hover:[background:var(--list-menu-hover-background)]"
        type="button"
      >
        @if (item.avatar) {
          <app-dynamic
            [props]="{ config: item.avatar }"
            class="shrink-0"
            componentName="Avatar"
          />
        }
        @if (item.icon) {
          <app-dynamic
            [props]="{ name: item.icon, color: 'var(--list-menu-icon-color)' }"
            class="shrink-0"
            componentName="SvgIcon"
          />
        }

        <div class="flex-1 flex flex-col gap-1 min-w-0">
          <span
            class="text-(--list-menu-title-color) font-semibold text-(length:--list-menu-title-size)"
            [style.font-size]="config().titleSize"
          >
            {{ item.title }}
          </span>
          @if (item.supportingText) {
            <span
              class="text-(--list-menu-support-text-color) text-sm font-(weight:--list-menu-support-text-font-weight,var(--font-weight-bold)) font-(family-name:--list-menu-support-text-font-family,var(--font-sans))"
              >{{ item.supportingText }}</span
            >
          }
        </div>

        @if (item.showChevron) {
          <app-dynamic
            [props]="{ name: 'caret-right', color: 'var(--list-menu-chevron-color)', size: '16' }"
            class="shrink-0"
            componentName="SvgIcon"
          />
        }
      </button>
    }
  </div>
}
